import './App.css';
import React from 'react';
import Home from './pages/home';


const App: React.FC = () => {
  return (
    <div className='app'>
      <Home />
    </div>
  )
}

export default App;

